<template>
  <pt-hospital-detail class="pt-hospital-detail__withData" :detail="detail"></pt-hospital-detail>
</template>

<script>
import PtHospitalDetail from './index'
export default {
  name: 'pt-hospital-detail__withData',
  components: {
    'pt-hospital-detail': PtHospitalDetail
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    getDetail () {
      this.$store.dispatch('getHospitalDetail', this.$route.params.id).then(ret => {
        this.detail = ret
      }).catch(err => {
        this.$message.error(err || '获取医院详情失败')
      })
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
